import React, { useEffect, useState } from "react";
import { LabelDollarFormatted, ButtonSizeOptions } from "@loanbossinc/component-library";
import CircularProgress from "@material-ui/core/CircularProgress";

import { LBRowContainer, LBRowDebtString, LBRowInfo, StyledPrimaryButton, StyledSecondaryButton, SelectDiv } from "./styles";

const formattedDollarLabel = (value) => (
  <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
    <LabelDollarFormatted
      value={(value && Math.abs(value)) || " "}
      hasAccountingFormat={value < 0}
      decimals={2}
      style={{ fontWeight: 420, color: value < 0 ? "#C40A0A" : "#000" }}
    />
  </div>
);

const RowContainer = ({ label, value, isSelected, isLoading, onClick }) => (
  <LBRowContainer>
    <LBRowInfo>
      <LBRowDebtString>{label}</LBRowDebtString>
    </LBRowInfo>
    {isLoading ? <CircularProgress size={20} style={{ color: "#005AA9" }} /> : formattedDollarLabel(value)}
    <SelectDiv>
      {isSelected ?
        <StyledSecondaryButton size={ButtonSizeOptions.smFluid} label="Selected" /> :
        <StyledPrimaryButton onClick={onClick} size={ButtonSizeOptions.smFluid} label="Select" />
      }
    </SelectDiv>
  </LBRowContainer>
);

const DerivedFromLBLineItem = props => {
  const {
    getLoanBalanceById,
    getLoanTotalBalanceById,
    activeLoanId, 
    isBalanceLoading,
    isTotalBalanceLoading,
    recentAsOfDate,
    setSelectedAmountValue,
    debtYieldCalculations,
    loanCurrentPrincipalBalance,
    loanTotalBalanceAmount,
    setIsOutstandingDebtSelected
  } = props;

  const currentCalculation = debtYieldCalculations.find(calc => calc.lineItem?.lineItemType === "derivedFromLB" && calc?.id === activeLoanId);

  const [outstandingDebtSelected, setOutstandingDebtSelected] = useState(() => {
    if (!currentCalculation) {
      return true;
    }
    return currentCalculation.lineItem.outstandingDebtSelected !== false;
  });

  useEffect(()=>{
    setIsOutstandingDebtSelected(outstandingDebtSelected);
  },[outstandingDebtSelected]);

  const handleClick = (newValue) => {
    setSelectedAmountValue(newValue);
    setOutstandingDebtSelected(prevState => !prevState);
    setIsOutstandingDebtSelected(outstandingDebtSelected);
  };

  useEffect(() => {
    if (activeLoanId && recentAsOfDate) {
      getLoanBalanceById({ loanId: activeLoanId, asOfDate: recentAsOfDate });
    }
  }, [activeLoanId, recentAsOfDate]);

  useEffect(() => {
    if (activeLoanId) {
      getLoanTotalBalanceById({ loanId: activeLoanId });
    }
  }, [activeLoanId, getLoanTotalBalanceById]);

  return (
    <div>
      <RowContainer
        label="Outstanding Debt"
        value={loanCurrentPrincipalBalance}
        isSelected={outstandingDebtSelected}
        isLoading={isBalanceLoading}
        onClick={() => handleClick(loanCurrentPrincipalBalance)}
      />
      <RowContainer
        label="Total Loan Amount"
        value={loanTotalBalanceAmount}
        isSelected={!outstandingDebtSelected}
        isLoading={isTotalBalanceLoading}
        onClick={() => handleClick(loanTotalBalanceAmount)}
      />
    </div>
  );
};

export default DerivedFromLBLineItem;
